import useAuth from "../hooks/useAuth";
import { useState, ReactNode, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { PATH_CHOOSE_ORGANISATION, PATH_LOGIN } from "src/routes/paths";
import { Storage } from "src/utils/storage";

export type AuthGuardProps = {
    children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
    const navigate = useNavigate();

    const { pathname } = useLocation();
    const [requestedLocation, setRequestedLocation] = useState<string | null>(null);
    const company = Storage.getItem("currentCompany");

    const { isAuthenticated } = useAuth();

    useEffect(() => {
        if (!isAuthenticated()) {
            navigate(PATH_LOGIN);
        }
    }, [isAuthenticated]);

    if (
        isAuthenticated() &&
        company === null &&
        pathname !== PATH_CHOOSE_ORGANISATION &&
        pathname.indexOf("register") === -1
    ) {
        return <Navigate to={PATH_CHOOSE_ORGANISATION} />;
    }

    if (!isAuthenticated()) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }

        return <Navigate to={PATH_LOGIN} />;
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation} />;
    }

    return <>{children}</>;
}
